/* MUI */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';

/*  Components  */
import CoverPage from '../Components/Containers/CoverPage';
import { AccountsOverview } from './internal/AccountsOverview';
import { SummaryCard } from './internal/AccountsSummaryCard';

export const AccountsInventoryReport = ({ reportSetup, reportData }) => {
    if (!reportData) {
        return null;
    }

    const {
        accountsInventoryAccountsInventoryAccountOverview,
        accountsInventoryAccountsInventoryAccountSummary
    } = reportData;

    return (
        <Box data-testid="accountsReportMainRender" width="100%">
            {reportSetup.reportSelections
                ?.accountsInventoryAccountsInventoryCover && (
                <CoverPage reportSetup={reportSetup} />
            )}
            <Box>
                {reportSetup.reportSelections
                    ?.accountsInventoryAccountsInventoryAccountSummary && (
                    <Box p="24px">
                        <SummaryCard
                            {...accountsInventoryAccountsInventoryAccountSummary}
                        />
                    </Box>
                )}
                {reportSetup.reportSelections
                    ?.accountsInventoryAccountsInventoryAccountOverview && (
                    <AccountsOverview
                        accounts={
                            accountsInventoryAccountsInventoryAccountOverview
                        }
                    />
                )}
            </Box>
        </Box>
    );
};
